import "./Gender.scss";
import {
  CONST_GENDER_FEMALE,
  CONST_GENDER_MALE,
  isValidGender,
  simplyClick,
} from "../../helpers";
import { useState, useEffect, useRef } from "react";
import Video from "../../video/video.mp4";
import Poster from "../../images/poster.jpg";

export const Gender = ({ data, setData, nextStep }) => {
  const [errorGender, setErrorGender] = useState(null);

  const handlerSubmit = (e) => {
    if (!isValidGender) {
      setErrorGender("Please choose,your gender.");
    } else {
      const value = parseInt(e.target.value);
      if (value === CONST_GENDER_MALE) {
        simplyClick("cl_lnd_st1_male");
      } else {
        simplyClick("cl_lnd_st1_female");
      }
      setData({ ...data, gender: parseInt(e.target.value) });
      nextStep();
    }
  };

  return (
    <form className="gender">
      <h1 className="global__title title__gender">Start something real!</h1>
      <p className="gender__text">
        Join our crowd and find your match. <br />
        To create an account, tell us about yourself.
      </p>
      <div className="video__wrapper">
        <video muted autoPlay playsInline loop poster={Poster}>
          <source src={Video} type="video/mp4" />
        </video>
      </div>
      <p className="gender__subtitle">You are a</p>
      <div className="form__gender">
        <label>
          <input
            onClick={(e) => handlerSubmit(e)}
            className="gender"
            type="radio"
            name="gender"
            value={CONST_GENDER_MALE}
          />
          <div className=" form__gender-male">
            <img src="./assets/images/male.svg" alt="icon" />
            <span>Man</span>
          </div>
        </label>
        <label>
          <input
            onClick={(e) => handlerSubmit(e)}
            className="gender"
            type="radio"
            name="gender"
            value={CONST_GENDER_FEMALE}
          />
          <div className=" form__gender-female">
            <img src="./assets/images/female.svg" alt="icon" />
            <span>Woman</span>
          </div>
        </label>
      </div>
      {errorGender && <p className="error-text">{errorGender}</p>}
      <div className="slider__box">
        <span className="step active"></span>
        <span className="step"></span>
        <span className="step"></span>
        <span className="step"></span>
        <span className="step"></span>
      </div>
    </form>
  );
};
